import { render, staticRenderFns } from "./core_list_item.vue?vue&type=template&id=06b51d73&scoped=true"
import script from "./core_list_item.vue?vue&type=script&lang=js"
export * from "./core_list_item.vue?vue&type=script&lang=js"
import style0 from "./core_list_item.vue?vue&type=style&index=0&id=06b51d73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b51d73",
  null
  
)

export default component.exports